/** The one colour every Usage bar is drawn in, on both products (MS-996;
 * spec §4.2-4, 18a-pal-i): Mambu MCP is a single series like Mambu Agents,
 * because pricing does not differentiate by invocation type, so the type is
 * not split out. It takes the same step as the User Limits bar rather than a
 * colour of its own — one product, one tint, and a tint the ramp already
 * contains (the prototype's `barHTML` / `initAgentsUsage`).
 *
 * In `lib/` rather than beside the components that render it so the file
 * exporting it stays a plain module (eslint react-refresh/only-export-components). */
export const SINGLE_SERIES_COLOR = 'var(--inv-auth)'
